export const OFFLINE_MODE = import.meta.env.VITE_OFFLINE_MODE === 'true';
export const OFFLINE_PROFILE_ID = 'local-offline';
